import { Card } from '../common/Card';
import { ResourceBar } from './ResourceBar';
import type { VpsStatus } from '../../types/vps';

interface SystemResourcesCardProps {
  status: VpsStatus | null;
}

function formatMemory(mb: number): string {
  if (mb >= 1024) return `${(mb / 1024).toFixed(1)} GB`;
  return `${mb} MB`;
}

export function SystemResourcesCard({ status }: SystemResourcesCardProps) {
  const hasDisk = status?.disk != null;
  const hasMemory = status?.memory != null;

  return (
    <Card title="System Resources">
      <div className="space-y-4 py-1">
        {hasDisk ? (
          <ResourceBar
            label="Disk"
            used={status!.disk!.used}
            total={status!.disk!.total}
            percent={status!.disk!.percent}
          />
        ) : (
          <p className="text-sm text-text-muted">Disk data unavailable</p>
        )}
        {hasMemory ? (
          <ResourceBar
            label="Memory"
            used={formatMemory(status!.memory!.used)}
            total={formatMemory(status!.memory!.total)}
            percent={status!.memory!.percent}
          />
        ) : (
          <p className="text-sm text-text-muted">Memory data unavailable</p>
        )}
      </div>
    </Card>
  );
}

export default SystemResourcesCard;
